var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('nav',{staticClass:"inline-nav",attrs:{"id":_vm.navId,"aria-label":_vm.label,"role":"navigation"}},[_c('ul',{attrs:{"role":"menubar"}},_vm._l((_vm.tabs),function(key,idx){return _c('li',{key:'nav-'+idx,class:{active: _vm.activeTab===idx}},[_c('button',{attrs:{"data-tabindex":idx},on:{"click":_vm.updateTab}},[_vm._v(_vm._s(key))])])}),0)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1af8d5e4","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/InlineNavigation.vue
// module id = null
// module chunks = 